import {
  formatInrPaise,
  renewalStatusHeading,
  type PublisherRenewalTransactionStatus,
  type RenewalQuote,
} from "../services/renewal";

type RenewalPaymentStatusPanelProps = {
  quote: RenewalQuote | null;
  status: PublisherRenewalTransactionStatus | null;
  polling: boolean;
  onRefresh?: () => void;
  onBack?: () => void;
};

export function RenewalPaymentStatusPanel({
  quote,
  status,
  polling,
  onRefresh,
  onBack,
}: RenewalPaymentStatusPanelProps) {
  if (!status && !quote) {
    return null;
  }

  const heading = status
    ? renewalStatusHeading(status.status)
    : "Renew selected app";

  return (
    <div aria-live="polite" className="oac-form-message">
      <p>
        <strong>{heading}</strong>
      </p>

      {quote && (
        <p>
          {quote.applicationName}. Annual renewal:{" "}
          {formatInrPaise(quote.nextRenewalPricePaise)}. Validity: +1 year.
        </p>
      )}

      {status && (
        <>
          <p>{status.message}</p>
          <p>
            Amount: {formatInrPaise(status.amountPaise)} ({status.currency}) via{" "}
            {status.provider}
          </p>
          {status.renewalCompleted && status.newExpiry && (
            <p>New expiry date: {new Date(status.newExpiry).toLocaleDateString("en-IN")}</p>
          )}
          {polling && !status.renewalCompleted && (
            <p>Checking payment status…</p>
          )}
        </>
      )}

      <div>
        {onRefresh && (
          <button
            className="oac-btn oac-btn--outline"
            disabled={polling}
            onClick={onRefresh}
            type="button"
          >
            Refresh status
          </button>
        )}
        {onBack && (
          <button
            className="oac-btn oac-btn--outline"
            onClick={onBack}
            type="button"
          >
            Back to dashboard
          </button>
        )}
      </div>
    </div>
  );
}
